<template>
    <div class="search-bar" :class="{ 'search-bar': true, active: isOpenInput }">
        <input
            v-if="isOpenInput"
            type="text"
            :placeholder="$t('searchPlaceholder', { count: activeProductCount })"
            :value="value"
            @focus="$emit('focus')"
            @input="updateInput"
        />
        <MyActionBtn
            :class="{ 'search-bar__button': true, active: isOpenInput }"
            :theme="'transparent-border'"
            :size="'small'"
            :type="'icon'"
            :icon="'search'"
            @click="setDisplayInput()"
        />
    </div>
</template>

<script>
import VueTypes from 'vue-types';
import { mapGetters } from 'vuex';

export default {
    name: 'SearchBar',
    props: {
        value: VueTypes.string.isRequired,
        isOpenInput: VueTypes.bool,
        setDisplayInput: VueTypes.func
    },
    components: {
        MyActionBtn: () => import('~/themes/ecaterix/components/ui/MyActionBtn')
    },
    computed: {
        ...mapGetters({
            activeProductCount: 'global/getActiveProductCount'
        })
    },
    methods: {
        updateInput(event) {
            const newVal = event.target.value;
            this.$emit('input', newVal);
        }
    }
};
</script>

<style lang="scss" scoped>
@import './styles.scss';
</style>
